import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { createSelectors } from "../core/utils/create-selectors";
import { DashboardStore, DashboardStoreActions } from "./types";

const initialState: DashboardStore = {
  participantType: "guest"
};

const useDashboardStoreBase = create(
  persist<DashboardStore & DashboardStoreActions>(
    (set) => ({
      ...initialState,
      selectParticipantType: (type) => set({ participantType: type })
    }),
    { name: "dasboard-store", storage: createJSONStorage(() => sessionStorage) }
  )
);

export const useDashboardStore = createSelectors(useDashboardStoreBase);
